import Jobs from "../Jobs/Jobs";

export default function ReleasePackagesLanding() {
  return (
    <Jobs
      detailBasePath="/release-packages"
      moduleTitle="Release Packages"
      showJobActions={false}
    />
  );
}
